import React from 'react';
import Avatar from '@mui/material/Avatar';

const UserAvatar = ({ name, sx, ...props }) => {
  const avatarUrl = `https://api.dicebear.com/9.x/initials/svg?seed=${name || ""}`;

  return (
    <Avatar
      alt={name}
      src={avatarUrl}
      className="text-white text-sm !mt-0"
      sx={sx}
      {...props}
    />
  );
};

export default UserAvatar;
